import styled from "styled-components";

import { FlexColumn } from "@similarweb/ui-components";
import { Flex } from "@similarweb/ui-components/foundations";

export const StyledContentWrapper = styled(FlexColumn)`
    align-self: center;
    max-width: 1368px;
    gap: 40px;
`;

export const StyledPremiumFeatureFilterContainer = styled(Flex)`
    align-items: center;
    flex-wrap: wrap;
    gap: 16px;
    max-width: 1368px;
`;
